var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeopleHeadsGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 140,
    viewBox: "0 0 146 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.976 108.975C95.8501 109.565 96.3915 110.384 97.2115 110.437C97.5761 110.463 97.9324 110.837 98.2929 111.004C99.1406 111.397 94.9982 111.469 95.72 111.469C88.6732 111.671 86.7844 109.107 82.677 105.153C74.2457 97.0527 74.5001 82.8001 74.5001 82.8001C78.6616 82.5712 82.1875 81.9429 81.9606 82.1718C81.249 82.9114 81.1145 83.7051 81.0526 84.7001C80.9718 86.5446 80.9617 88.5457 81.9606 90.001C82.1381 90.2526 82.9073 91.4757 83.7782 91.9001C84.9194 92.4562 86.2001 92.2289 86.2001 92.5635C86.199 93.287 86.1307 93.8348 86.2001 94.2744C86.3429 95.1789 86.0347 95.9088 86.454 97.3195C86.9104 98.5786 86.7319 98.7505 87.1418 99.2788C90.2901 103.285 92.377 107.214 94.976 108.975ZM137.381 82.1367C137.702 81.9545 139.258 81.9545 142.05 82.1367C142.05 82.3279 142.104 82.6012 142.1 82.8001C141.894 92.6892 136.607 111.755 136.607 111.755C134.47 109.963 131.724 109.933 128.699 110.365C127.401 110.551 126.051 110.822 124.676 111.075C123.348 111.32 121.995 111.548 120.643 111.667L117.755 111.755C118.235 111.623 120.992 110.182 121.445 109.734C127.533 103.72 127.88 103.165 131.1 96.712C131.22 96.4714 130.974 95.5598 131.1 95.3001C131.181 95.1328 131.054 95.0446 131.1 94.8632C131.272 94.1883 131.332 94.3116 131.307 93.7251C131.296 93.4443 131.309 92.7981 131.444 92.3537C131.461 92.2964 131.479 92.2386 131.497 92.1804C132.471 89.0271 134.385 84.6384 135.986 82.1367C136.761 80.9261 136.713 82.4893 137.381 82.1367Z",
    fill: "#1F323D",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.5 86.5C99.5 88 99.2 89.2 98.7 89.2C98.2 89.2 97.8 88 97.8 86.5C97.8 85 98.2 83.7 98.7 83.7C99.2 83.7 99.5 85 99.5 86.5Z",
    fill: "#1F323D",
    stroke: "#1F323D",
    strokeWidth: 0.361491
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120 86.5C120 88 119.6 89.2 119.2 89.2C118.8 89.2 118.3 88 118.3 86.5C118.3 85 118.7 83.7 119.2 83.7C119.7 83.7 120 85 120 86.5Z",
    fill: "#1F323D",
    stroke: "#1F323D",
    strokeWidth: 0.361491
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.3 79.2C104.3 80.6 96.8 79.4 95.5 79.6C94.2 79.8 91.1 81.2 91 81C91.9296 79.7216 93.2171 78.7473 94.7 78.2C96.2 77.7 104.3 77.9 104.3 79.2Z",
    fill: "#1F323D",
    stroke: "#1F323D",
    strokeWidth: 0.161497
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.5 81.0001C126.4 81.2001 123.3 79.8001 122 79.6001C120.7 79.4001 113.2 80.6001 113.2 79.2001C113.2 77.8001 121.3 77.7001 122.8 78.2001C124.25 78.8058 125.523 79.7691 126.5 81.0001Z",
    fill: "#1F323D",
    stroke: "#1F323D",
    strokeWidth: 0.161443
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M103 103.4C103 103.4 106.3 105.9 109.7 105.3",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M106.9 95.7999C107.228 96.2049 107.678 96.4919 108.183 96.6179C108.688 96.7439 109.221 96.7029 109.7 96.4999C111.5 95.7999 110.7 90.3999 110.7 90.3999",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.9 80.7999C131.9 80.7999 135.6 80.5999 135.6 85.6999C135.6 90.7999 133.5 91.8999 131 91.8999",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M131.9 80.7999C131.9 80.7999 135.6 80.5999 135.6 85.6999C135.6 90.7999 133.5 91.8999 131 91.8999",
    stroke: "#1F323D",
    strokeWidth: 0.75
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M131.5 92.0001L130 98.9001C125.371 107.259 117.611 113.108 108.5 115.985C99.411 113.113 91.8807 107.259 87.3 98.9001L85.5 88.6001",
    stroke: "#1F323D",
    strokeWidth: 0.75
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.1 82.6H136.7C115.9 75.8 90.7 48.8 90.7 48.8C90.7 48.8 116 45.5 127.8 51.2C139.6 56.9 142.1 82.6 142.1 82.6Z",
    fill: "#1F323D",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.3 53.6C98.3 53.6 89.6119 75.1689 82.6119 81.6689L74.5 82.8C74.5 82.8 77.7 65.1 83.4 58.9C89.1 52.7 98.3 53.6 98.3 53.6Z",
    fill: "#1F323D",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2 60.5999C31.544 61.0127 32.0117 61.3038 32.5341 61.4299C33.0564 61.556 33.6055 61.5104 34.0999 61.2999C35.9999 60.5999 34.4 51.3999 34.4 51.3999",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.9001 51.2001C44.9001 52.7001 44.5001 54 44.0001 54C43.5001 54 43.1001 52.7001 43.1001 51.2001C43.1001 49.7001 43.5001 48.3 44.0001 48.3C44.5001 48.3 44.9001 49.6001 44.9001 51.2001Z",
    fill: "#1F323D",
    stroke: "#1F323D",
    strokeWidth: 0.359704
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3 58.5L54.3 71.3001C54.3 71.3001 40.0001 84.7 32.9001 84.7C25.8001 84.7 11.6 71.3001 11.6 71.3001L10.3 53.8",
    stroke: "#1F323D",
    strokeWidth: 0.75
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1001 48.4C57.1001 48.4 60.7001 43.6 60.7001 49.3C60.7001 55 58.8001 59.3 56.1001 59.3",
    stroke: "#1F323D",
    strokeWidth: 0.75
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79994 59.3C6.89995 59.3 5.19995 55 5.19995 49.3C5.19995 43.6 8.79994 48.4 8.79994 48.4",
    stroke: "#1F323D",
    strokeWidth: 0.75
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4001 37.2L55.6001 52.9",
    stroke: "#1F323D",
    strokeWidth: 0.75
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M9.90005 48.2999L9.80005 36.8999",
    stroke: "#1F323D",
    strokeWidth: 0.75
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4 51.2001C23.4 52.7001 23 54 22.5 54C22 54 21.7 52.7001 21.7 51.2001C21.7 49.7001 22 48.3 22.5 48.3C23 48.3 23.4 49.6001 23.4 51.2001Z",
    fill: "#1F323D",
    stroke: "#1F323D",
    strokeWidth: 0.359704
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7 43.5999C27.7 45.1999 20.5 43.6999 19 43.8999C17.5 44.0999 13.8 45.8999 13.8 45.6999C13.8 45.4999 16.2 42.7999 18 42.2999C19.8 41.7999 27.7 41.8999 27.7 43.5999Z",
    fill: "#1F323D",
    stroke: "#1F323D",
    strokeWidth: 0.179852
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.3999 45.7C52.2999 45.9 48.5999 44.2 47.0999 43.9C45.5999 43.6 38.3999 45.2 38.3999 43.6C38.3999 42 46.2999 41.8 48.0999 42.3C49.8999 42.8 52.4999 45.4 52.3999 45.7Z",
    fill: "#1F323D",
    stroke: "#1F323D",
    strokeWidth: 0.179852
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6001 68.8999C27.7474 70.0851 30.1482 70.7368 32.6001 70.7999",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.6 36.7001L0.5 36.2001C0.5 34 5.4 30.3 5.4 30.3C5.3 17.7 12.5 3.80005 28.2 3.80005H37.9C53.7 3.80005 60.8 17.7 60.7 30.3C60.7 30.3 65.6 34 65.6 36.2001V36.7001Z",
    fill: "#CDD9E2",
    stroke: "#CDD9E2",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.5999 65.5C79.4999 52.4 88.9999 38.7 105.4 38.7H112.6C128.9 38.7 138.4 52.4 138.3 65.5H79.5999Z",
    fill: "#B4C5D0",
    stroke: "#B4C5D0",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.5 72.2H73.1001L79.6001 65.5H138.3L145.5 72.2Z",
    fill: "#B0C6D1",
    stroke: "#B0C6D1",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7999 74.3999C13.7999 82.3999 11.9999 87.1999 10.2999 89.7999L5.19995 95.2999",
    stroke: "#1F323D",
    strokeWidth: 0.75
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8001 93.4999L55.5001 89.5999C53.9001 86.9999 52.1001 82.2999 52.1001 74.3999",
    stroke: "#1F323D",
    strokeWidth: 0.75
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4999 97.4001C42.5774 100.169 37.901 101.669 33.0999 101.7C18.8999 101.7 11.8999 89.1001 11.8999 89.1001",
    stroke: "#1F323D",
    strokeWidth: 0.75
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8999 15.6V0.5H37.1999V15.6",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M3.69995 21.3L13.4999 25.6V28.6",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6001 29.3V25.6L62.4001 21.3",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M131.1 129.4L126.3 126.5C122.619 122.411 120.588 117.101 120.6 111.6",
    stroke: "#1F323D",
    strokeWidth: 0.75
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6 111.6C96.627 117.008 94.6702 122.238 91.1 126.3L85.5 130.9",
    stroke: "#1F323D",
    strokeWidth: 0.75
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M118.9 135.3C116.199 137.947 112.582 139.451 108.8 139.5C97.6 139.5 92.8 126.3 92.8 126.3",
    stroke: "#1F323D",
    strokeWidth: 0.75
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M104.7 49.5V35.2H113.2V49.5",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8 56.1001L88 60.6001V64.4001",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M129.9 65.2001V60.6001L140.1 56.1001",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2 91.9001C83.5 91.9001 81.3 90.9001 81.3 85.7001C81.3 80.5001 85.2 80.8001 85.2 80.8001",
    stroke: "#1F323D",
    strokeWidth: 0.75
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.7223 80.5294C84.7527 80.2633 84.9387 79.598 85.1537 78.9999C85.337 78.4898 85.8425 77.5758 85.911 77.4716C86.0598 77.2452 84.7761 78.9999 84.5 78.9999C84.2239 78.9999 84 79.2238 84 79.4999C84 79.7761 84.6661 81.0225 84.7223 80.5294Z",
    fill: "#D8D8D8",
    stroke: "#1F323D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleHeadsGrey);
export default __webpack_public_path__ + "static/media/people_heads_grey.58731c882be98ded2d1cde3f58b7d669.svg";
export { ForwardRef as ReactComponent };